var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"ibcgp-fiscais-note",attrs:{"aria-label":"Informação complementar"}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"ibcgp-fiscais-note-text mb-0 text-center"},[_c('a',{staticClass:"ibcgp-fiscais-note-link",attrs:{"href":"/fiscais"}},[_vm._v("\n        Credenciamento para fiscais em processos seletivos\n      ")])])])])
}]

export { render, staticRenderFns }